import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import SingleSelect from '../../../../components/SingleSelect';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  status?: string;
  fullAddress?: string;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  status: undefined,
  fullAddress: undefined,
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof FilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('mapTool.addressBlacklist.filters.status'),
    t('mapTool.addressBlacklist.filters.fullAddress'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  const statusOptions = [
    { label: t('mapTool.addressBlacklist.status.active'), value: 'active' },
    { label: t('mapTool.addressBlacklist.status.expired'), value: 'expired' },
  ];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <SingleSelect
            label={t('mapTool.addressBlacklist.filters.status')}
            options={statusOptions}
            value={filters.status}
            onChange={(v) => handleChange('status', v)}
            spanClassName={labelClassName}
            allowClear
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressBlacklist.filters.fullAddress')}
            value={filters.fullAddress ?? ''}
            onChange={(e) => handleChange('fullAddress', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressBlacklist.placeholders.fullAddressFuzzy') as string}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterArea;